export default "__VITE_ASSET__444e78d7__$_?component__"